<template>
<v-list v-if="inline" class="py-0">
  <slot></slot>
</v-list>
<v-dialog v-model="sheet" scrollable v-else>
     <template v-slot:activator="{ on, attrs }">
        <slot name="activator">
        <v-list class="pa-0" >
                <v-divider></v-divider>
            <v-list-item v-bind="attrs"
          v-on="on"
                   
                    >
                    <v-list-item-icon class="mr-3" v-if="icon">
                        <v-icon v-text="icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                    <v-list-item-title>{{ value }}</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        {{detail}}
                    </v-list-item-action>
                    <v-list-item-icon>
                        <v-icon>arrow_drop_down</v-icon>
                    </v-list-item-icon>
                    
                    </v-list-item>
                    <v-divider></v-divider>
            </v-list>
            </slot>
      </template>
     <v-card>
        <v-toolbar flat tile><v-toolbar-title v-text="title"></v-toolbar-title>
        <v-spacer></v-spacer>
        <!--v-btn icon @click="close"><v-icon>close</v-icon></v-btn-->
        </v-toolbar>
  
       
       
        <v-card-text style="ma-height: 50vh" class="pa-0 py-5">
            <slot></slot>
        </v-card-text>
        <v-card-actions>
          <span class="caption grey--text">* = Inclusief</span>
           <v-spacer></v-spacer>
            <v-btn text @click="close" color="primary">Klaar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>

export default {

   props: {
    value: {
      type: String,
      default: function () {
        return 'Maak een keuze'
      },
    },
    title: {
      type: String,
      default: function () {
        return 'Maak een keuze'
      },
    },
    detail: {
      type: String,
      default: function () {
        return null
      },
    },
    icon: {
      type: String,
      default: function () {
        return null
      },
    },
    multiple: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    inline: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    show: {
      type: Boolean,
      default: function () {
        return false
      },
    },
   },
  data: () => ({
     sheet:false
  }),
  computed: {
   
  },
  mounted () {
  
  },
  destroyed() {
      this.$emit('close')
    },
watch: {
    value(value){
        if (!this.multiple) this.sheet = false        
    },
    show(value){
       this.sheet =value
    },
    sheet(value){
      if (!value) this.$emit('close')
    }
},
methods: {
  close(){
      this.sheet=false
    }
 }
}

</script>
